var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg5(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 35.2,
    height: 35.2,
    rx: 17.6,
    fill: "#FFF2D2"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6100_8049)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.7262 12.0215H13.5398C13.6563 12.0215 13.7502 12.1153 13.7502 12.2318V12.6042C13.7502 12.7208 13.6563 12.8146 13.5398 12.8146H11.7262C11.6096 12.8146 11.5158 12.7208 11.5158 12.6042V12.2318C11.5158 12.1153 11.6096 12.0215 11.7262 12.0215Z",
    fill: "#F5A730"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.4603 12.0204H24.2711C24.3877 12.0204 24.4815 12.1142 24.4815 12.2308V12.6032C24.4815 12.7197 24.3877 12.8107 24.274 12.8107H22.4632C22.3466 12.8107 22.2528 12.7169 22.2528 12.6003V12.2279C22.2528 12.1114 22.3466 12.0176 22.4632 12.0176L22.4603 12.0204Z",
    fill: "#F5A730"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.4445 10.918H15.0095V12.8112H15.4445V10.918Z",
    fill: "#F5A730"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.8161 10H21.1838C21.3003 10 21.3941 10.0938 21.3941 10.2104V10.705C21.3941 10.8215 21.3003 10.9154 21.1838 10.9154H14.8161C14.6996 10.9154 14.6057 10.8215 14.6057 10.705V10.2104C14.6057 10.0938 14.6996 10 14.8161 10Z",
    fill: "#F5A730"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.9877 10.918H20.5556V12.8112H20.9877V10.918Z",
    fill: "#F5A730"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27 23.8757C27 24.5352 26.4656 25.0668 25.8061 25.0668H10.1939C9.53443 25.0668 9 24.5324 9 23.8757V14.3981C9 13.7386 9.53443 13.207 10.1939 13.207H25.8089C26.4684 13.207 27.0028 13.7415 27.0028 14.3981V23.8729L27 23.8757ZM21.1383 18.1164H19.0205V15.9986C19.0205 15.7768 18.8414 15.5977 18.6197 15.5977H17.3831C17.1614 15.5977 16.9823 15.7768 16.9823 15.9986V18.1164H14.8617C14.6399 18.1164 14.4608 18.2955 14.4608 18.5172V19.7538C14.4608 19.9755 14.6399 20.1546 14.8617 20.1546H16.9823V22.2753C16.9823 22.497 17.1614 22.6761 17.3831 22.6761H18.6197C18.8414 22.6761 19.0205 22.497 19.0205 22.2753V20.1546H21.1383C21.3601 20.1546 21.5392 19.9755 21.5392 19.7538V18.5172C21.5392 18.2955 21.3601 18.1164 21.1383 18.1164Z",
    fill: "#F5A730"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6100_8049"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 15.0663,
    fill: "white",
    transform: "translate(9 10)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg5);
export default __webpack_public_path__ + "static/media/5.f1c0caec308ee936f2e399ce28c496c3.svg";
export { ForwardRef as ReactComponent };